const zhCN = {
    "component":{
        "ZmDialog":{
            "内容有修改":"内容有修改，是否确认关闭？",
            "确定":"确定",
            "提示":"提示",
            "取消":"取消"
        },
        "ZmTable":{
            "序号":"序号",
            "复制当前行":"复制当前行",
            "复制选择行":"复制选择行",
            "复制所有行":"复制所有行",
            "请选择数据列或未获取到数据":"请选择数据列或未获取到数据",
            "以下单号在查询结果中不存在：":'以下单号在查询结果中不存在：',
            "共":"共",
            "笔":"笔",
            "以下单号存在重复：":"以下单号存在重复：",
            "复制区域内容":"复制区域内容",
            "内容已复制到粘贴板":"内容已复制到粘贴板",
            "复制失败！":"复制失败！",
        },
        "ZmTableConfig":{
            "表格配置":"表格配置",
            "可选格式":"可选格式",
            "保存":"保存",
            "另存为":"另存为",
            "删除":"删除",
            "序号":"序号",
            "字段名称":"字段名称",
            "输入关键字搜索":"输入关键字搜索",
            "是否显示":"是否显示",
            "排序":"排序",
            "重排":"重排",
            "列宽":"列宽",
            "顺序重置":"顺序重置",
            "注意：关于列宽调整，需在主页面上设置好，再做保存":"注意：关于列宽调整，需在主页面上设置好，再做保存",
            "保存并加载":"保存并加载",
            "取消":"取消",
            "请选择数据":"请选择数据",
            "已经是列表中第一条数据！":"已经是列表中第一条数据！",
            "请选择列":"请选择列",
            "已经是列表中最后一条数据！":"已经是列表中最后一条数据！",
            "请输入模版名称":"请输入模版名称",
            "提示":"提示",
            "确定":"确定",
            "表格配置另存为成功":'表格配置另存为成功',
            "表格配置另存为失败":"表格配置另存为失败",
            "取消另存为":"取消另存为",
            "必须设置显示列":"必须设置显示列",
            "请设置配置信息":"请设置配置信息",
            "请选择表格配置":"请选择表格配置",
            "是否删除此格式":"是否删除此格式",
            "格式删除成功":'格式删除成功',
            "格式删除失败":'格式删除失败',
            "请选择格式":"请选择格式",
            "表格配置信息保存成功":"表格配置信息保存成功",
            "表格配置信息保存失败":"表格配置信息保存失败",
        },
        "ZmImpBtn":{
            "可用格式":"可用格式",
            "字段编码":"字段编码",
            "序号":"序号",
            "请输入格式名称":"请输入格式名称",
            "列号":"列号|标题",
            "必填":"必填",
            "另存为":"另存为",
            "删除":"删除",
            "是否对模版字段进行修改":"是否对模版字段进行修改",
            "保存":"保存",
            "模版保存成功":"模版保存成功",
            "通过列号定位列":"通过列号定位列",
            "请选择导入格式":"请选择导入格式",
            "未获取到对应的类型字段信息":"未获取到对应的类型字段信息",
            "加载":"加载",
            "表头信息有误":"表头信息有误",
            "请选择格式":"请选择格式",
            "模版删除成功":"模版删除成功",
            "取消另存为":"取消另存为",
            "导入Excel标题":"导入Excel标题",
            "确定":"确定",
            "请设置导入列":"请设置导入列",
            "列名称":"列名称",
            "是否删除此模版":"是否删除此模版",
            "否":"否",
            "提示":"提示",
            "Excel导入自定义格式设置":"Excel导入自定义格式设置",
            "字段名":"字段名",
            "识别列号":"识别列号",
            "是":"是",
            "确定删除此行吗":"确定删除此行吗",
            "取消":"取消",
            "模版另存为成功":"模版另存为成功",
            "标题导入成功":"标题导入成功,可自行设置",
            "自定义格式":"自定义格式",
            "取消修改":"取消修改",
            "操作":"Operation ",
            "是否保存为通用模版":"Whether to save as a universal template "
        },
        "ZmBaseExport":{
            "创建导出任务失败":"创建导出任务失败！",
            "直接导出表格中可以看到的所有列":"直接导出表格中可以看到的所有列",
            "创建导出任务成功":"创建导出任务成功，请稍后在导出列表中下载！",
            "请选择一条数据":"请选择一条数据",
            "导出可视列":"导出可视列",
            "另存为":"另存为",
            "删除":"删除",
            "是否对模版字段进行修改":"是否对模版字段进行修改",
            "保存":"保存",
            "获取表格列信息失败":"获取表格列信息失败!",
            "请选择通用模版":"请选择通用模版",
            "模版保存成功":"模版保存成功",
            "自定义导出":"自定义导出",
            "Excel自定义导出":"Excel自定义导出&",
            "模版删除失败":"模版删除失败",
            "可选格式":"可选格式",
            "模版删除成功":"模版删除成功",
            "请选择数据":"请选择数据",
            "取消另存为":"取消另存为",
            "确定":"确定",
            "列名称":"列名称",
            "是否删除此模版":"是否删除此模版",
            "提示":"提示",
            "请稍后在导出列表中下载":"请稍后在导出列表中下载",
            "模版保存失败":"模版保存失败",
            "请选择导出列":"请选择导出列",
            "请输入模版名称":"请输入模版名称",
            "导出":"导出",
            "取消":"取消",
            "模版另存为成功":"模版另存为成功",
            "导出列":"导出列",
            "待导出列":"待导出列",
            "已经是列表中最后一条数据":"已经是列表中最后一条数据",
            "取消修改":"取消修改",
            "模版另存为失败":"模版另存为失败",
            "已经是列表中第一条数据":"已经是列表中第一条数据",
            "创建导出任务成功，请在导出列表中进行下载": "创建导出任务成功，请在导出列表中进行下载"
        },
        "ZmMessage":{
            "下一条":"下一条",
            "忽略":"忽略",
            "回复":"回复",
            "已是最后一条消息2秒后自动关闭":"已是最后一条消息2秒后自动关闭",
            "不再提醒":"不再提醒",
            "新消息":"新消息"
        },
        "zmCallTable":{
            "请选择数据":"请选择数据",
            "序号":"序号",
            "编码":"编码",
            "名称":"名称",
            "调用表配置加载失败":"调用表配置加载失败，请联系管理员！",
            "调用表信息不存在":"调用表信息不存在,请联系管理员!",
            "移除监听":"移除监听",
            "刷新":"刷新",
            "开启监听":"开启监听",
            "查找":"查找",
            "输入框回车":"输入框回车",
            "取消":"取消",
            "选取":"选取",
            "未查询到数据":"未查询到数据，请重新输入！"
        },
        "Developmenting":{
            "程序正在加紧研发":"程序正在加紧研发，敬请期待。。。"
        },
        "ZmToolBox":{
            "请选择打印机":"请选择打印机",
            "打印类型数据有误":"打印类型数据有误",
            "选择模板":"选择模板",
            "打印参数不能为空":"打印参数不能为空",
            "缩放类型只能为":"缩放类型只能为0,1,2",
            "请输入文件地址":"请输入文件地址",
            "上下偏差只能输入数字":"上下偏差只能输入数字",
            "旋转类型只能为":"旋转类型只能为0,1,2,3",
            "报表类型不能为空":"报表类型不能为空",
            "偏差值只能在30和-30之间":"偏差值只能在30和-30之间！",
            "打印方式只能为":"打印方式只能为'sys','pdf'!",
            "单位":"单位",
            "打印窗口":"打印窗口",
            "是否预览":"是否预览",
            "获取对应打印格式的对象数据":"获取对应打印格式的对象数据",
            "请传入打印参数":"请传入打印参数",
            "保存为默认":"保存为默认",
            "打印份数":"打印份数",
            "打印机":"打印机",
            "打印失败":"打印失败",
            "上下偏差":"上下偏差",
            "左右偏差只能输入数字":"左右偏差只能输入数字",
            "来源类型不能为空":"来源类型不能为空",
            "导出窗口":"导出窗口",
            "打印成功":"打印成功",
            "该打印模版未设计模版":"该打印模版未设计模版，请先设计后再打印",
            "该导出模版未设计模版":"该导出模版未设计模版，请先设计后再导出",
            "打印类型不能为空":"打印类型不能为空",
            "打印场景":"打印场景",
            "文件地址":"文件地址",
            "保存默认配置成功":"保存默认配置成功",
            "来源类型只能为":"来源类型只能为'Base64','http','RawText','LocalFile'四种之一",
            "打印场景不能为空":"打印场景不能为空",
            "打印数据来源不能为空":"打印数据来源不能为空",
            "请选择运单打印机":"请选择运单打印机",
            "毫米":"毫米",
            "判断参数":"判断参数",
            "请选择模版":"请选择模版",
            "打印":"打印",
            "导出":"导出",
            "左右偏差":"左右偏差",
            "物流助手初始化失败":"物流助手初始化失败，请稍后重试"
        },
        "ImportLog":{
            "查询":"查询",
            "导入网点":"导入网点",
            "批次号":"批次号",
            "导入人":"导入人",
            "重置":"重置",
            "状态":"状态",
            "总行数":"总行数",
            "导入文件":"导入文件",
            "网点":"网点",
            "错误描述":"错误描述",
            "导入时间":"导入时间",
            "错误行数":"错误行数"
        },
        /* zmfront-framework */
        "CallTable":{
            "调用表配置加载失败":"调用表配置加载失败，请联系管理员！",
            "调用表信息不存在":"调用表信息不存在，请联系管理员！"
        },
        "TreeTable":{
            "序号":"序号"
        },
        "zmExportButton":{
            "创建导出任务失败":"创建导出任务失败！",
            "创建导出任务成功":"创建导出任务成功，请稍后在导出列表中下载！",
            "请选择一条数据":"请选择一条数据",
            "另存为":"另存为",
            "删除":"删除",
            "是否对模版字段进行修改":"是否对模版字段进行修改",
            "保存":"保存",
            "请选择通用模版":"请选择通用模版",
            "模版保存成功":"模版保存成功",
            "自定义导出":"自定义导出",
            "Excel自定义导出":"Excel自定义导出",
            "模版删除失败":"模版删除失败",
            "可选格式":"可选格式",
            "模版删除成功":"模版删除成功",
            "请选择数据":"请选择数据",
            "取消另存为":"取消另存为",
            "确定":"确定",
            "列名称":"列名称",
            "是否删除此模版":"是否删除此模版",
            "提示":"提示",
            "模版保存失败":"模版保存失败",
            "请选择导出列":"请选择导出列",
            "请输入模版名称":"请输入模版名称",
            "请选择指定模版":"请选择指定模版",
            "导出":"导出",
            "取消":"取消",
            "模版另存为成功":"模版另存为成功",
            "导出列":"导出列",
            "待导出列":"待导出列",
            "已经是列表中最后一条数据":"已经是列表中最后一条数据",
            "取消修改":"取消修改",
            "模版另存为失败":"模版另存为失败",
            "已经是列表中第一条数据":"已经是列表中第一条数据",
            "创建导出任务成功，请在导出列表中进行下载": "创建导出任务成功，请在导出列表中进行下载"
        },
        "SimpleTable":{
            "选项表配置加载失败":"选项表配置加载失败，请联系管理员!"
        },
        "CommonTable":{
            "再做保存":"再做保存",
            "表格配置信息保存失败":"表格配置信息保存失败",
            "请选择列":"请选择列",
            "表格配置":"表格配置",
            "另存为":"另存为",
            "以下单号在查询结果中不存在":"以下单号在查询结果中不存在",
            "保存":"保存",
            "笔":"笔",
            "输入关键字搜索":"输入关键字搜索",
            "附件":"附件",
            "请选择数据":"请选择数据",
            "格式删除成功":"格式删除成功",
            "表格配置另存为失败":"表格配置另存为失败",
            "注意":"注意",
            "排序":"排序",
            "序号":"序号",
            "删除":"删除",
            "以下单号存在重复":"以下单号存在重复",
            "提示":"提示",
            "是否显示":"是否显示",
            "是否删除此格式":"是否删除此格式",
            "共":"共",
            "重排":"重排",
            "取消":"取消",
            "复制当前行":"复制当前行",
            "已经是列表中最后一条数据":"已经是列表中最后一条数据",
            "请选择过滤数据列":"请选择过滤数据列",
            "已经是列表中第一条数据":"已经是列表中第一条数据",
            "需在主页面上设置好":"需在主页面上设置好",
            "请设置配置信息":"请设置配置信息",
            "复制所有行":"复制所有行",
            "保存并加载":"保存并加载",
            "复制选择行":"复制选择行",
            "必须设置显示列":"必须设置显示列",
            "列宽":"列宽",
            "顺序重置":"顺序重置",
            "可选格式":"可选格式",
            "表格配置信息保存成功":"表格配置信息保存成功",
            "请选择格式":"请选择格式",
            "表格配置另存为成功":"表格配置另存为成功",
            "关于列宽调整":"关于列宽调整",
            "格式删除失败":"格式删除失败",
            "请选择数据列或未获取到数据":"请选择数据列或未获取到数据",
            "请选择表格配置":"请选择表格配置",
            "配置":"配置",
            "取消另存为":"取消另存为",
            "确定":"确定",
            "复制区域内容":"复制区域内容",
            "请输入模版名称":"请输入模版名称",
            "数据":"数据",
            "过滤值":"过滤值",
            "取消删除":"取消删除"
        },
        "ZmDate":{
            "最近两天":"最近两天",
            "开始日期":"开始日期",
            "日期跨度不能超过":"日期跨度不能超过",
            "天":"天",
            "一周前":"一周前",
            "昨天":"昨天",
            "最近一周":"最近一周",
            "最近一个月":"最近一个月",
            "结束日期":"结束日期",
            "一月前":"一月前",
            "最近三个月":"最近三个月",
            "今天":"今天",
            "当天":"当天"
        },
        "tagsView":{
            "关闭所有":"关闭所有",
            "关闭其他":"关闭其他"
        },
        "zmFileUpload":{
            "点击上传":"点击上传",
            "导入":"导入",
            "导入Excel标题":"导入Excel标题",
        },
        "ZmNo":{
            "清":"清",
            "空":"空",
            "个":"个",
            "单号不能超过":"单号不能超过"
        },
        "ZmMsgSend":{
            "短信通知":"短信通知",
            "接收人":"接收人",
            "接收人手机":"接收人手机",
            "发送":"发送",
            "关闭":"关闭",
            "发送失败":"发送失败",
            "发送成功":"发送成功",
        },
        "ZmPrintChildNo":{
            "Label打印":"Label打印",
            "单件补打":"单件补打",
            "打单信息":"打单信息",
            "运单号码":"运单号码",
            "转单号码":"转单号码",
            "走货路线":"走货路线",
            "寄件帐号":"寄件帐号",
            "件数":"件数",
            "注意":"注意",
            "可选择指定的子单进行补单":"可选择指定的子单进行补单",
            "用于单件货物联破损":"用于单件货物联破损",
            "只适用于号码段分配":"只适用于号码段分配",
            "如DHL5.3系统号码段分配":"如DHL5.3系统号码段分配",
            "和子单有独立PDF的接口":"和子单有独立PDF的接口",
            "如":"如",
            "下载":"下载",
            "打印":"打印",
            "预览":"预览",
            "关闭":"关闭",
            "子单号码":"子单号码",
            "没有子单列表":"没有子单列表",
            "请选择需要下载的数据":"请选择需要下载的数据",
            "请选择需要预览的数据":"请选择需要预览的数据",
            "不支持预览的格式":"不支持预览的格式",
            "获取子单的PDF合并文件异常":"获取子单的PDF合并文件异常",
            "不支持的格式":"不支持的格式",
            "没有可以打印数据":"没有可以打印数据",
            "单件信息中没有Label不能打印":"单件信息中没有Label不能打印",
        },
        "ZmInvoicePreApplyBatch":{
            "补录信息":"补录信息",
            "运单号码":"运单号码",
            "补录原因":"补录原因",
            "费用信息":"费用信息",
            "科目":'科目',
            "计算公式":"计算公式",
            "金额":"金额",
            "币别":"币别",
            "账单备注":"账单备注",
            "内部备注":'内部备注',
            "保存并继续":"保存并继续",
            "保存":"保存",
            "关闭":"关闭",
            "请输入正确的公式":"请输入正确的公式",
            "当前":"当前",
            "笔单号有问题":"笔单号有问题",
            "批量添加":"批量添加",
            "笔单号":"笔单号",
        },
        "ZmAgentRegistrationAfter":{
            "问题件信息":"问题件信息",
            "问题单号":"问题单号",
            "问题状态":"问题状态",
            "截止处理时间":"截止处理时间",
            "问题描述":"问题描述",
            "处理状态":"处理状态",
            "通知人":"通知人",
            "可多选":"可多选",
            "登记":"登记",
            "关闭":"关闭",
            "登记异常":"登记异常",
            "登记成功":"登记成功",
            "文件大小不能大于5MB":"文件大小不能大于5MB",
            "只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
            "获取问题状态信息失败":"获取问题状态信息失败",
            "获取运单信息失败":"获取运单信息失败",
            "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
            "提示":"提示",
            "确定":'确定',
            "取消":"取消",
            "问题号码":"问题号码",
            "多笔转单/运单回车换行输入":"多笔转单/运单回车换行输入",
            "批量登记":"批量登记",
            "批量登记异常":"批量登记异常",
            "当前有":"当前有",
            "笔运单未能成功登记问题件":"笔运单未能成功登记问题件",
            "批量登记成功！":"批量登记成功！",
        },
        "ZmPrintGeneral":{
            "打印窗口":"打印窗口",
            "选择模板":"选择模板",
            "打印机":"打印机",
            "打印":"打印",
            "预览":"预览",
            "保存默认":"保存默认",
            "关闭":'关闭',
            "请选择要打印的打单记录！":"请选择要打印的打单记录！",
            "请先配置LABEL打印机":"请先配置LABEL打印机",
            "请先配置INVOICE打印机":'请先配置INVOICE打印机',
            "请先配置备份联打印机":'请先配置备份联打印机',
            "请先配置电池信打印机":'请先配置电池信打印机',
            "没有找到打印配置":'没有找到打印配置',
            "获取合并文件异常，稍后重试！":'获取合并文件异常，稍后重试！',
            "获取默认模版异常！":"获取默认模版异常！",
            "没有设置模板！":'没有设置模板！',
            "获取模板列表异常！":"获取模板列表异常！",
            "无Invoice":"无Invoice",
            "无备份联":"无备份联",
            "没有配置自定义输出方式":"没有配置自定义输出方式",
            "获取api打单参数异常！":"获取api打单参数异常！",
            "模板不能为空":"模板不能为空",
            "打印机不能为空":"打印机不能为空",
            "保存默认打印机成功！":"保存默认打印机成功！",
        },
        "ZmProblems":{
            "问题件信息":"问题件信息",
            "运单号码":"运单号码",
            "转单号码":"转单号码",
            "处理网点":"处理网点",
            "客户信息":"客户信息",
            "指定路线":"指定路线",
            "走货路线":"走货路线",
            "件数/收费重":"件数/收费重",
            "目的地/收件邮编":"目的地/收件邮编",
            "问题描述":"问题描述",
            "处理意见":"处理意见",
            "输入处理意见后，可Enter/回复提交":"输入处理意见后，可Enter/回复提交",
            "处理状态":"处理状态",
            "处理结果":"处理结果",
            "通知人(可多选)":"通知人(可多选)",
            "回复":"回复",
            "关闭":"关闭",
            "获取文件路径异常":"获取文件路径异常",
            "文件大小不能大于15MB":"文件大小不能大于15MB",
            "只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
            "文件还未上传成功，请等待文件上传成功后再回复！":"文件还未上传成功，请等待文件上传成功后再回复！",
            "处理状态不能为空":"处理状态不能为空",
            "确定申请退返客户吗?":"确定申请退返客户吗?",
            "提示":"提示",
            "确定":"确定",
            "取消":"取消",
            "确定申请销毁吗?":"确定申请销毁吗?",
            "回复异常":"回复异常",
            "回复成功！":"回复成功！",
            "问题状态":"问题状态",
            "附件":"附件",
            "指定处理人":"指定处理人",
            "处理时限":"处理时限",
            "登记":"登记",
            "登记异常":"登记异常",
            "登记成功！":"登记成功！",
            "获取问题状态信息失败！":"获取问题状态信息失败！",
            "获取运单信息失败！":"获取运单信息失败！",
            "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
            "截止处理时间":"截止处理时间",
            "需回复":"需回复",
            "文件大小不能大于5MB":"文件大小不能大于5MB",
            "多笔运单回车换行输入":"多笔运单回车换行输入",
            "批量登记":"批量登记",
            "批量登记异常":"批量登记异常",
            "当前有":"当前有",
            "笔运单未能成功登记问题件":"笔运单未能成功登记问题件",
            "批量登记成功！":"批量登记成功！",
            "多笔转单/运单回车换行输入":"多笔转单/运单回车换行输入",
            "问题件回复":"问题件回复",
            "运单号码/转单号码/参考编号":"运单号码/转单号码/参考编号",
            "收件城市/收件邮编":"收件城市/收件邮编",
            "目的地":"目的地",
            "指定路线/走货路线":"指定路线/走货路线",
        },
        "PosPrintSetting":{
            "打印设置":"打印设置",
            "打印机设置":"打印机设置",
            "LABEL打印机":"LABEL打印机",
            "INVOICE打印机":"INVOICE打印机",
            "备份联打印机":"备份联打印机",
            "电池信打印机":"电池信打印机",
            "文件保存路径":"文件保存路径",
            "发票份数":"发票份数",
            "备份联份数":"备份联份数",
            "是否合并":"是否合并",
            "打印类型":"打印类型",
            "关闭":"关闭",
            "保存":"保存",
            "发票份数不能为空且必须大于0":"发票份数不能为空且必须大于0",
            "备份联份数不能为空且必须大于0":"备份联份数不能为空且必须大于0",
        }
    }
};
export default zhCN;



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/locale/components_zh-CN.js